/**
 * Конвертация ключей объектов между camelCase ↔ snake_case.
 *
 * Бэк отдаёт snake_case и ждёт snake_case в теле запроса. Гоняем
 * автоматически в `http.ts` interceptor'ах, чтобы код домена писался
 * на нативном camelCase.
 *
 * Если бэк когда-нибудь начнёт отдавать camelCase напрямую — обёртка
 * становится no-op, можно будет выпилить одним флагом.
 */

type Json = unknown;

const snakeToCamel = (s: string): string =>
  s.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());

const camelToSnake = (s: string): string => s.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);

const isPlainObject = (v: unknown): v is Record<string, unknown> => {
  if (v === null || typeof v !== 'object') return false;
  const proto = Object.getPrototypeOf(v);
  return proto === Object.prototype || proto === null;
};

export const toCamel = (input: Json): Json => {
  if (Array.isArray(input)) return input.map(toCamel);
  if (isPlainObject(input)) {
    const out: Record<string, Json> = {};
    for (const [k, v] of Object.entries(input)) {
      out[snakeToCamel(k)] = toCamel(v);
    }
    return out;
  }
  return input;
};

export const toSnake = (input: Json): Json => {
  if (Array.isArray(input)) return input.map(toSnake);
  if (isPlainObject(input)) {
    const out: Record<string, Json> = {};
    for (const [k, v] of Object.entries(input)) {
      out[camelToSnake(k)] = toSnake(v);
    }
    return out;
  }
  return input;
};
